import React, { useState } from 'react';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import OrgTotalUsers from './OrgTotalUsers';
import OrgListUsersScreen from './OrgListUsersScreen';
import OrgBotsUserScreen from './OrgBotsUserScreen';

/**
 * Component for display the correct page that was selected
 *
 * @param {string} { filter, subPage }
 * @returns
 */
const OrgUsersReport = ({ filter, subPage }) => {
  const [parentFilter, setParentFilter] = useState(filter);

  /**
   * Call when the filter button on the FilterData is called
   */
  const onClickFilter = async () => {
    setParentFilter(filter);
  };

  const pages = {
    orgTotalUsers: (
      <OrgTotalUsers
        parentFilter={parentFilter}
        onClickFilter={onClickFilter}
      />
    ),
    orgListUsers: (
      <OrgListUsersScreen
        parentFilter={parentFilter}
        onClickFilter={onClickFilter}
      />
    ),
    orgBotsUser: (
      <OrgBotsUserScreen
        parentFilter={parentFilter}
        onClickFilter={onClickFilter}
      />
    ),
  };

  return <div>{pages[subPage]}</div>;
};

const mapStateToProps = (state) => {
  return {
    filter: state.filter,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(OrgUsersReport)
);
